<div class="row">
  <div class="col-md-12" *ngFor="let inf of listInfluencers; let i = index">
    <preview-influencer-item [influencer]="inf"
                             [evenRow]="i % 2 === 0"
                             [previewedMode]="true"
                             [displayInfo]="displayInfo">
    </preview-influencer-item>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/preview-selected-influencers/preview-selected-influencers.component.html